<div class="acca-boost-sports">{{ sitecore.accaBoost.AllSports }}</div>
@if (notification.token.boostLadder.length) {
    <div class="acca-boost-parlay-markets">
        {{ sitecore.accaBoost.MinSelections }} {{ notification.token.boostLadder[0].numberOfLegs }} •
        {{ sitecore.accaBoost.MaxSelections }}
        {{ notification.token.boostLadder[notification.token.boostLadder.length - 1].numberOfLegs }} • {{ sitecore.accaBoost.MinOddsLimit }}
        {{ notification.token.filter.minOddsPerLeg.american }}
    </div>
}
